// react
import React from "react";

// utils
import toEmployeeUrl from "../../utils/URLs/Employee";

import PropTypes from "../../lib/prop-types";

// components
import Avatar from "../Avatar";
// styles
import css from "./Person.module.scss";

/**
 * @deprecated use AvatarProfile in py-components instead
 */
const Person = ({
	className = "",
	id,
	name,
	linkActive = true,
	noLinkTooltips = false,
	avatarOnly = false,
	avatarSize = 25,
	fontSize = 16,
	linkOpenNewTab = false,
}) => {
	return (
		<div className={`${css.employeeContainer} ${className}`} data-testid="person">
			{noLinkTooltips ? (
				<div data-userid={id} style={{ cursor: "pointer" }}>
					<a href={toEmployeeUrl(id)} target={linkOpenNewTab ? "_blank" : undefined}>
						<Avatar id={id} size={avatarSize} />
					</a>
				</div>
			) : (
				<div>
					<Avatar id={id} size={avatarSize} />
				</div>
			)}
			{!noLinkTooltips && !avatarOnly && linkActive ? (
				<div className={`${css.employeeName} ${css.employeeNameLink}`} style={{ fontSize: `${fontSize}px` }}>
					<a href={toEmployeeUrl(id)} target={linkOpenNewTab ? "_blank" : undefined}>
						{name}
					</a>
				</div>
			) : null}
			{!avatarOnly && !linkActive && noLinkTooltips ? (
				<div
					className={`${css.employeeName}`}
					data-userid={id}
					style={{
						fontSize: `${fontSize}px`,
						cursor: "pointer",
					}}
					target={linkOpenNewTab ? "_blank" : undefined}
				>
					{name}
				</div>
			) : null}
			{!avatarOnly && !linkActive && !noLinkTooltips ? (
				<div
					className={`${css.employeeName}`}
					data-userid={id}
					style={{
						fontSize: `${fontSize}px`,
						cursor: "auto",
					}}
					target={linkOpenNewTab ? "_blank" : undefined}
				>
					<a
						className="text-neutral-9"
						href={toEmployeeUrl(id)}
						target={linkOpenNewTab ? "_blank" : undefined}
						onClick={(e) => e.preventDefault()}
					>
						{name}
					</a>
				</div>
			) : null}
		</div>
	);
};

Person.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	linkActive: PropTypes.bool,
	noLinkTooltips: PropTypes.bool,
	avatarOnly: PropTypes.bool,
	avatarSize: PropTypes.number,
	fontSize: PropTypes.number,
	linkOpenNewTab: PropTypes.bool,
};

export default Person;
